<template>
  <div
      @click='$emit("toggleRound", votingRound.id)'
      class="mb-3 position-relative sidebar-card highlight-hover p-3 rounded h5"
      :class='selected ? "bg-theme" : "bg-blur-darker text-white"'
  >
    <i class="fas fa-vote-yea"></i> {{ label }}
  </div>
</template>

<script>
import {label} from "../../entrypoints/shared/voting_rounds_helper.js";

export default {
  name: "VotingRound",
  components: {},
  props: {
    votingRound: Object,
    selected: false,
    roundState: String,
  },
  computed: {
    label() {
      return label(this.votingRound, this.$i18n.locale);
    },
  },
}
</script>
<style scoped>
.highlight-hover:hover {
  cursor: pointer;
  box-shadow: 0 0 0 2px white;
}
</style>